// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../../intl/Intl_Utils.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../../../theme/Theme_Colors.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Correct_Box$DvmAdminFrontendFr from "../Order_Detail_Correct_Box.bs.js";

function Order_Detail_Correct_Vehicle_History_Content(Props) {
  var correction = Props.correction;
  var color = Props.color;
  var title = Props.title;
  var form = Props.form;
  var intl = ReactIntl.useIntl();
  var match = form.input.orderType;
  var tmp;
  var exit = 0;
  switch (match) {
    case /* SO */0 :
    case /* ES */8 :
    case /* RS */10 :
    case /* SM */11 :
    case /* AS */15 :
        tmp = [];
        break;
    case /* CL */1 :
    case /* VE */2 :
    case /* VD */3 :
    case /* RR */4 :
    case /* RC */5 :
    case /* PG */6 :
    case /* EP */7 :
    case /* RP */9 :
    case /* TT */12 :
    case /* AD */13 :
    case /* AP */14 :
    case /* NOTSET */16 :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp = [
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.valueVO,
            children: Belt_Option.mapWithDefault(correction.realTradeAmount, "-", (function (eta) {
                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                  }))
          }),
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.estimatedValueVO,
            children: Belt_Option.mapWithDefault(correction.estimatedTradeAmount, "-", (function (eta) {
                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                  }))
          }),
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.endOfLifeVO,
            children: Belt_Option.mapWithDefault(correction.scrapyardIndicator, "-", (function (x) {
                    return intl.formatMessage(x ? Messages_Common$DvmAdminFrontendFr.yes : Messages_Common$DvmAdminFrontendFr.no);
                  }))
          })
    ];
  }
  return React.createElement(Order_Detail_Correct_Box$DvmAdminFrontendFr.make, {
              content: Belt_Array.concat([
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.reprPoliceNumber,
                          children: Belt_Option.getWithDefault(correction.usedCarPoliceNumber, "-")
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDate,
                          children: Belt_Option.mapWithDefault(correction.usedCarLastRegistrationDate, "-", (function (param) {
                                  return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                }))
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.registrationVO,
                          children: Belt_Option.getWithDefault(correction.usedCarRegistrationID, "-")
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.reprDatePremiere,
                          children: Belt_Option.mapWithDefault(correction.usedCarFirstReleaseDate, "-", (function (param) {
                                  return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                }))
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.brandVO,
                          children: Belt_Option.getWithDefault(correction.brandUsedCar, "-")
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.modelVO,
                          children: Belt_Option.getWithDefault(correction.modelUsedCar, "-")
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.versionVO,
                          children: Belt_Option.getWithDefault(correction.versionUsedCar, "-")
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.vinVO,
                          children: Belt_Option.getWithDefault(correction.vinUsedCar, "-")
                        })
                  ], tmp),
              bgcolor: Theme_Colors$DvmAdminFrontendFr.grayLight1,
              color: color,
              title: title
            });
}

var make = Order_Detail_Correct_Vehicle_History_Content;

export {
  make ,
}
/* react Not a pure module */
